module.exports = __webpack_public_path__ + "img/logo-cn.c4cd3c3d.png";